import { autoinject, customElement } from 'aurelia-framework';
import { EventHelper } from 'framework/aurelia_tools/event-helper';

@autoinject
@customElement('download-toolbar-component')
export class DownloadToolbarComponent {
  constructor(private eventHelper: EventHelper) {
  }

  donwload() {
    this.eventHelper.publish('toolbar-download');
  }
}
